export class SearchResources200ResponseTablesInnerTablesInnerColumnsInner {
    'name';
    'type';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResources200ResponseTablesInnerTablesInnerColumnsInner.attributeTypeMap;
    }
    constructor() {
    }
}
